module.exports = __webpack_public_path__ + "media/prize.6f88.wav";